import { MapPin, Phone, Clock } from "@phosphor-icons/react";
import { Separator } from "@/components/ui/separator";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[hsl(222,47%,11%)] text-stone-300 noise-overlay">
      <div className="relative z-10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Brand */}
            <div>
              <h3 className="font-heading font-extrabold text-xl text-white tracking-tight mb-4">
                Mobile Mechanic PDX
              </h3>
              <p className="text-sm leading-relaxed text-stone-400 max-w-xs">
                Portland's solution to the "traditional garage headache." Professional, ASE-style expertise delivered directly to your driveway.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading font-bold text-sm text-white uppercase tracking-widest mb-4">
                Quick Links
              </h4>
              <nav className="flex flex-col gap-3">
                {[
                  { label: "Home", href: "#hero" },
                  { label: "Why Us", href: "#why-us" },
                  { label: "About", href: "#about" },
                  { label: "Services", href: "#services" },
                  { label: "Reviews", href: "#reviews" },
                  { label: "Contact", href: "#contact" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="text-sm text-stone-400 hover:text-primary transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-heading font-bold text-sm text-white uppercase tracking-widest mb-4">
                Contact
              </h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin weight="duotone" className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                  <p className="text-sm text-stone-400">
                    15206 NW Sweetgale Ln,
                    <br />
                    Portland, OR 97229
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <Phone weight="duotone" className="w-4 h-4 text-primary shrink-0" />
                  <a
                    href="tel:+15034828686"
                    className="text-sm text-stone-400 hover:text-primary transition-colors duration-200"
                    data-testid="footer-phone-link"
                  >
                    (503) 482-8686
                  </a>
                </div>
                <div className="flex items-start gap-3">
                  <Clock weight="duotone" className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                  <div className="text-sm text-stone-400">
                    <p>Mon: 5:30 AM – 5:30 PM</p>
                    <p>Sun: 9:00 AM – 3:00 PM</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-stone-800" />

        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-500">
            &copy; {currentYear} Mobile Mechanic PDX. All rights reserved.
          </p>
          <p className="text-xs text-stone-500">
            Professional On-Site Automotive Service
          </p>
        </div>
      </div>
    </footer>
  );
}
